<script lang="ts">
    // Stores
    import { getI18n } from '~/stores/i18n';

    // Constants
    import { items } from '~/constants/footer-items';

    // Shared Components
    import Footer from '@amp/web-app-components/src/components/Footer/Footer.svelte';
    import LocaleSwitcherButton from '@amp/web-app-components/src/components/buttons/LocaleSwitcherButton/LocaleSwitcherButton.svelte';

    // Utils
    import {
        regions,
        languages,
        storefrontNameTranslations,
    } from '~/utils/storefront-data';
    import { getLocale } from '~/utils/locale';

    // Types
    import type { Page } from '~/jet/models';

    // Stores
    import { showFooter } from '~/stores/show-footer';

    export let page: Promise<Page>;

    const i18n = getI18n();
    const locale = getLocale();
</script>

{#await page then}
    <!-- No Footer or Locale Switcher on Library Pages (2 column layout) & other 2 column layout as 1st column in listpage is infinite scroll -->
    {#if $showFooter}
        <Footer footerItems={items} translateFn={$i18n.t}>
            <svelte:fragment slot="secondary-content">
                <LocaleSwitcherButton
                    translateFn={$i18n.t}
                    {regions}
                    {languages}
                    {locale}
                    {storefrontNameTranslations}
                    defaultRoute=""
                />
            </svelte:fragment>
        </Footer>
    {/if}
{/await}
